import React from 'react';
import {Link} from "react-router-dom";
import instagramIcon from "../../img/socials/instagram.svg";
import whatsappIcon from "../../img/socials/whatsapp.svg";
import facebookIcon from "../../img/socials/facebook.svg";
import youtubeIcon from "../../img/socials/youtube.svg";

export const SocialMediaBranchComponent = ({socialLink}) => {
    if (!socialLink) return null;

    const links = [
        { name: "instagram", icon: instagramIcon, url: socialLink.instagram },
        { name: "facebook", icon: facebookIcon, url: socialLink.facebook },
        { name: "youtube", icon: youtubeIcon, url: socialLink.youtube },
        { name: "whatsapp", icon: whatsappIcon, url: socialLink.whatsapp },
    ];

    const activeLinks = links.filter(link => link.url);

    if (activeLinks.length === 0) return null;

    return (
        <div className="d-flex justify-content-start gap-3 w-100 mt-3">
            {activeLinks.map(link => (
                <Link
                    key={link.name}
                    to={link.url}
                    target="_blank"
                >
                    <img className="d-block" src={link.icon} width={18} height={18} alt={link.name}/>
                </Link>
            ))}
        </div>
    );
};